import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = { class: "grid grid-cols-1 lg:grid-cols-3 gap-6" };
const _hoisted_2 = { class: "flex flex-col gap-6" };
const _hoisted_3 = { class: "flex flex-col gap-3 py-2" };
const _hoisted_4 = { class: "flex items-center justify-between text-sm" };
const _hoisted_5 = { class: "text-(--colors-text-secondary)" };
const _hoisted_6 = { class: "font-semibold" };
const _hoisted_7 = { class: "w-full h-2 rounded-full bg-(--colors-border-base-soft) overflow-hidden" };
const _hoisted_8 = { class: "text-xs text-(--colors-text-secondary)" };
import { computed } from "vue";
import { RouterLink } from "vue-router";
import { Accordion, AccordionItem, DatePickerInput, TextInput, WidgetShell, formatPhoneForDisplay, } from "@eudonet/opal";
import { useI18n } from "vue-i18n";
import { useFinanceFormatters } from "@/shared/composables/useFinanceFormatters";
import { isoToDisplayDate, toDatePickerFormat } from "@/shared/utils/date-formatting";
import { useProfileStore } from "@/modules/settings/public";
import { buildContactRoute, buildDonorRoute, buildOrganisationRoute } from "../../composables/donorRoute";
export default /*@__PURE__*/ _defineComponent({
    __name: 'SubscriptionTabResume',
    props: {
        state: {},
        donorStats: {}
    },
    setup(__props) {
        const props = __props;
        // Donor link target — resolves to a CRM contact (Individual) or organisation
        // (Organization); null when the CRM reference isn't available, so the donor name
        // renders as plain text instead of a link that 404s.
        const donorRoute = computed(() => buildDonorRoute(props.state));
        // OP-5843: an Organisation subscription shows two donor rows — the organisation and its
        // referent contact ("Contact référent"), each linking to its own CRM record.
        const organisationRoute = computed(() => buildOrganisationRoute(props.state.organizationId));
        const contactRoute = computed(() => buildContactRoute(props.state.contactId));
        const formattedDonorPhone = computed(() => formatPhoneForDisplay(props.state.donorPhone ?? ""));
        const { t, locale } = useI18n();
        const { formatAmount } = useFinanceFormatters();
        const profileStore = useProfileStore();
        // The dates are stored ISO (`yyyy-MM-dd`); DatePickerInput parses its value with `format`, and
        // without one it reads that ISO string as mm/dd/yyyy and shows garbage such as "20/26/1014".
        const dateFormat = computed(() => toDatePickerFormat(profileStore.profile?.dateFormat, locale.value));
        const toDisplay = (iso) => isoToDisplayDate(iso ?? "", profileStore.profile?.dateFormat, locale.value);
        const startDateDisplay = computed(() => toDisplay(props.state.startDate));
        const endDateDisplay = computed(() => toDisplay(props.state.endDate));
        const nextDueDateDisplay = computed(() => toDisplay(props.state.nextDueDate));
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", null, [
                    _createVNode(_unref(Accordion), {
                        variant: "default",
                        multiple: true,
                        "heading-level": 2
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_unref(AccordionItem), {
                                title: _ctx.$t('finance.subscriptions.sections.amountFrequency'),
                                "default-open": true
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_unref(TextInput), {
                                        label: _ctx.$t('finance.subscriptions.fields.id'),
                                        "model-value": __props.state.id,
                                        disabled: true,
                                        "full-width": ""
                                    }, null, 8 /* PROPS */, ["label", "model-value"]),
                                    _createVNode(_unref(TextInput), {
                                        label: _ctx.$t('finance.subscriptions.fields.merchantId'),
                                        "model-value": __props.state.merchantId ?? '',
                                        disabled: true,
                                        "full-width": ""
                                    }, null, 8 /* PROPS */, ["label", "model-value"]),
                                    _createVNode(_unref(TextInput), {
                                        label: _ctx.$t('finance.subscriptions.fields.initialAmount'),
                                        "model-value": _unref(formatAmount)(__props.state.initialAmount, __props.state.currency),
                                        disabled: true,
                                        "full-width": ""
                                    }, null, 8 /* PROPS */, ["label", "model-value"]),
                                    _createVNode(_unref(TextInput), {
                                        label: _ctx.$t('finance.subscriptions.fields.amount'),
                                        "model-value": _unref(formatAmount)(__props.state.amount, __props.state.currency),
                                        disabled: true,
                                        "full-width": ""
                                    }, null, 8 /* PROPS */, ["label", "model-value"]),
                                    _createVNode(_unref(TextInput), {
                                        label: _ctx.$t('finance.subscriptions.fields.frequency'),
                                        "model-value": __props.state.frequency ? _unref(t)(`finance.subscriptions.frequency.${__props.state.frequency}`) : '–',
                                        disabled: true,
                                        "full-width": ""
                                    }, null, 8 /* PROPS */, ["label", "model-value"]),
                                    _createVNode(_unref(TextInput), {
                                        label: _ctx.$t('finance.subscriptions.fields.installmentCount'),
                                        "model-value": __props.state.installmentCount != null ? String(__props.state.installmentCount) : '–',
                                        disabled: true,
                                        "full-width": ""
                                    }, null, 8 /* PROPS */, ["label", "model-value"])
                                ]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["title"]),
                            _createVNode(_unref(AccordionItem), {
                                title: _ctx.$t('finance.subscriptions.sections.campaign'),
                                "default-open": true
                            }, {
                                default: _withCtx(() => [
                                    (__props.state.campaignId)
                                        ? (_openBlock(), _createBlock(_unref(RouterLink), {
                                            key: 0,
                                            to: { name: 'CampaignDetail', params: { id: __props.state.campaignId } },
                                            class: "block",
                                            "aria-label": `${_ctx.$t('finance.subscriptions.fields.campaignLinked')}: ${__props.state.campaignName ?? ''}`
                                        }, {
                                            default: _withCtx(() => [
                                                _createVNode(_unref(TextInput), {
                                                    label: _ctx.$t('finance.subscriptions.fields.campaignLinked'),
                                                    "model-value": __props.state.campaignName ?? '',
                                                    disabled: true,
                                                    "value-variant": "link",
                                                    "full-width": ""
                                                }, null, 8 /* PROPS */, ["label", "model-value"])
                                            ]),
                                            _: 1 /* STABLE */
                                        }, 8 /* PROPS */, ["to", "aria-label"]))
                                        : (_openBlock(), _createBlock(_unref(TextInput), {
                                            key: 1,
                                            label: _ctx.$t('finance.subscriptions.fields.campaignLinked'),
                                            "model-value": '',
                                            disabled: true,
                                            "full-width": ""
                                        }, null, 8 /* PROPS */, ["label"]))
                                ]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["title"]),
                            _createVNode(_unref(AccordionItem), {
                                title: _ctx.$t('finance.subscriptions.sections.donor'),
                                "default-open": true
                            }, {
                                default: _withCtx(() => [
                                    (__props.state.donorType === 'Organization')
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                            (organisationRoute.value)
                                                ? (_openBlock(), _createBlock(_unref(RouterLink), {
                                                    key: 0,
                                                    to: organisationRoute.value,
                                                    class: "block",
                                                    "aria-label": `${_ctx.$t('finance.donations.fields.orgName')}: ${__props.state.donorName}`
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createVNode(_unref(TextInput), {
                                                            label: _ctx.$t('finance.donations.fields.orgName'),
                                                            "model-value": __props.state.donorName,
                                                            disabled: true,
                                                            "value-variant": "link",
                                                            "full-width": ""
                                                        }, null, 8 /* PROPS */, ["label", "model-value"])
                                                    ]),
                                                    _: 1 /* STABLE */
                                                }, 8 /* PROPS */, ["to", "aria-label"]))
                                                : (_openBlock(), _createBlock(_unref(TextInput), {
                                                    key: 1,
                                                    label: _ctx.$t('finance.donations.fields.orgName'),
                                                    "model-value": __props.state.donorName,
                                                    disabled: true,
                                                    "full-width": ""
                                                }, null, 8 /* PROPS */, ["label", "model-value"])),
                                            (contactRoute.value)
                                                ? (_openBlock(), _createBlock(_unref(RouterLink), {
                                                    key: 2,
                                                    to: contactRoute.value,
                                                    class: "block",
                                                    "aria-label": `${_ctx.$t('finance.donations.fields.donorContact')}: ${__props.state.contactDisplayName ?? ''}`
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createVNode(_unref(TextInput), {
                                                            label: _ctx.$t('finance.donations.fields.donorContact'),
                                                            "model-value": __props.state.contactDisplayName ?? '',
                                                            disabled: true,
                                                            "value-variant": "link",
                                                            "full-width": ""
                                                        }, null, 8 /* PROPS */, ["label", "model-value"])
                                                    ]),
                                                    _: 1 /* STABLE */
                                                }, 8 /* PROPS */, ["to", "aria-label"]))
                                                : (_openBlock(), _createBlock(_unref(TextInput), {
                                                    key: 3,
                                                    label: _ctx.$t('finance.donations.fields.donorContact'),
                                                    "model-value": __props.state.contactDisplayName ?? '',
                                                    disabled: true,
                                                    "full-width": ""
                                                }, null, 8 /* PROPS */, ["label", "model-value"]))
                                        ], 64 /* STABLE_FRAGMENT */))
                                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                            (donorRoute.value)
                                                ? (_openBlock(), _createBlock(_unref(RouterLink), {
                                                    key: 0,
                                                    to: donorRoute.value,
                                                    class: "block",
                                                    "aria-label": `${_ctx.$t('finance.subscriptions.fields.donor')}: ${__props.state.donorName}`
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createVNode(_unref(TextInput), {
                                                            label: _ctx.$t('finance.subscriptions.fields.donor'),
                                                            "model-value": __props.state.donorName,
                                                            disabled: true,
                                                            "value-variant": "link",
                                                            "full-width": ""
                                                        }, null, 8 /* PROPS */, ["label", "model-value"])
                                                    ]),
                                                    _: 1 /* STABLE */
                                                }, 8 /* PROPS */, ["to", "aria-label"]))
                                                : (_openBlock(), _createBlock(_unref(TextInput), {
                                                    key: 1,
                                                    label: _ctx.$t('finance.subscriptions.fields.donor'),
                                                    "model-value": __props.state.donorName,
                                                    disabled: true,
                                                    "full-width": ""
                                                }, null, 8 /* PROPS */, ["label", "model-value"]))
                                        ], 64 /* STABLE_FRAGMENT */)),
                                    (__props.state.donorPhone)
                                        ? (_openBlock(), _createBlock(_unref(TextInput), {
                                            key: 2,
                                            label: _ctx.$t('finance.donations.fields.donorPhone'),
                                            "model-value": formattedDonorPhone.value,
                                            disabled: true,
                                            "full-width": ""
                                        }, null, 8 /* PROPS */, ["label", "model-value"]))
                                        : _createCommentVNode("v-if", true),
                                    (__props.state.donorEmail)
                                        ? (_openBlock(), _createBlock(_unref(TextInput), {
                                            key: 3,
                                            label: _ctx.$t('finance.donations.fields.donorEmail'),
                                            "model-value": __props.state.donorEmail,
                                            disabled: true,
                                            "full-width": ""
                                        }, null, 8 /* PROPS */, ["label", "model-value"]))
                                        : _createCommentVNode("v-if", true)
                                ]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["title"]),
                            _createVNode(_unref(AccordionItem), {
                                title: _ctx.$t('finance.subscriptions.sections.dates'),
                                "default-open": true
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_unref(DatePickerInput), {
                                        label: _ctx.$t('finance.subscriptions.fields.startDate'),
                                        "model-value": startDateDisplay.value,
                                        format: dateFormat.value,
                                        language: _unref(locale),
                                        disabled: true,
                                        "full-width": ""
                                    }, null, 8 /* PROPS */, ["label", "model-value", "format", "language"]),
                                    (__props.state.endDate)
                                        ? (_openBlock(), _createBlock(_unref(DatePickerInput), {
                                            key: 0,
                                            label: _ctx.$t('finance.subscriptions.fields.endDate'),
                                            "model-value": endDateDisplay.value,
                                            format: dateFormat.value,
                                            language: _unref(locale),
                                            disabled: true,
                                            "full-width": ""
                                        }, null, 8 /* PROPS */, ["label", "model-value", "format", "language"]))
                                        : _createCommentVNode("v-if", true),
                                    (__props.state.nextDueDate)
                                        ? (_openBlock(), _createBlock(_unref(DatePickerInput), {
                                            key: 1,
                                            label: _ctx.$t('finance.subscriptions.fields.nextDueDate'),
                                            "model-value": nextDueDateDisplay.value,
                                            format: dateFormat.value,
                                            language: _unref(locale),
                                            disabled: true,
                                            "full-width": ""
                                        }, null, 8 /* PROPS */, ["label", "model-value", "format", "language"]))
                                        : _createCommentVNode("v-if", true),
                                    _createVNode(_unref(TextInput), {
                                        label: _ctx.$t('finance.subscriptions.fields.paymentMethod'),
                                        "model-value": __props.state.paymentMethod
                                            ? _unref(t)(`finance.subscriptions.paymentMethod.${__props.state.paymentMethod}`)
                                            : '–',
                                        disabled: true,
                                        "full-width": ""
                                    }, null, 8 /* PROPS */, ["label", "model-value"])
                                ]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["title"])
                        ]),
                        _: 1 /* STABLE */
                    })
                ]),
                _createElementVNode("div", _hoisted_2, [
                    (__props.state.installmentCount)
                        ? (_openBlock(), _createBlock(_unref(WidgetShell), {
                            key: 0,
                            header: _ctx.$t('finance.subscriptions.fields.installmentCount')
                        }, {
                            default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_3, [
                                    _createElementVNode("div", _hoisted_4, [
                                        _createElementVNode("span", _hoisted_5, _toDisplayString(__props.donorStats.paymentCount) + " / " + _toDisplayString(__props.state.installmentCount), 1 /* TEXT */),
                                        _createElementVNode("span", _hoisted_6, _toDisplayString(Math.round((__props.donorStats.paymentCount / __props.state.installmentCount) * 100)) + "%", 1 /* TEXT */)
                                    ]),
                                    _createElementVNode("div", _hoisted_7, [
                                        _createElementVNode("div", {
                                            class: "h-full rounded-full bg-green-500 transition-all",
                                            style: _normalizeStyle({
                                                width: `${Math.min(100, Math.round((__props.donorStats.paymentCount / __props.state.installmentCount) * 100))}%`,
                                            })
                                        }, null, 4 /* STYLE */)
                                    ]),
                                    _createElementVNode("p", _hoisted_8, _toDisplayString(__props.state.installmentCount - __props.donorStats.paymentCount) + " " + _toDisplayString(_ctx.$t("finance.subscriptions.detail.installmentsRemaining")), 1 /* TEXT */)
                                ])
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["header"]))
                        : _createCommentVNode("v-if", true)
                ])
            ]));
        };
    }
});
